<template>
  <div>
    <el-dialog
      :title="title"
      :visible.sync="visible"
      width="700px"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <el-form
        :model="dataForm"
        :rules="rules"
        ref="dataForm"
        label-width="120px"
        @keyup.enter.native="submitForm()"
      >
        <el-form-item label="设备名称" prop="deviceName">
          <el-input
            v-model="dataForm.deviceName"
            placeholder="请输入设备名称"
            show-word-limitmaxlength="25"
          ></el-input>
        </el-form-item>

        <el-form-item label="设备唯一凭证" prop="uniqueAddress">
          <el-input
            v-model="dataForm.uniqueAddress"
            placeholder="建议使用设备MAC地址，大写并以:分隔"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input
            type="textarea"
            :rows="4"
            v-model="dataForm.remark"
            placeholder="请输入设备备注"
            maxlength="100"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm()">确定</el-button>
        <el-button @click="resetForm()">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import httpMethods from '@/api/equipment/http.js'
export default {
  data() {
    return {
      type: 1, // 1新增，2编辑
      title: '新增设备白名单',
      proId: '',
      visible: false,
      dataForm: {
        deviceName: ' ',
        uniqueAddress: '',
        remark: ''
      },
      rules: {
        deviceName: [
          { required: true, message: '请输入设备名称', trigger: 'blur' },
          { max: 25, message: '最多25字', trigger: 'blur' }
        ],
        uniqueAddress: [
          { required: true, message: '请输入设备唯一凭证', trigger: 'blur' }
          //   { max: 25, message: '最多25字', trigger: 'blur' }
        ],
        remark: [
          { message: '请输入备注', trigger: 'blur' },
          { max: 100, message: '最多100字', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init(info, proId) {
      this.proId = proId
      this.visible = true
      if (info === '') {
        // 新增
        this.type = 1
        this.title = '新增设备白名单'
        this.$nextTick(() => {
          this.$refs.dataForm.resetFields()
          this.dataForm.deviceName = ''
          this.dataForm.uniqueAddress = ''
          this.dataForm.remark = ''
        })
      } else {
        // 编辑
        this.title = '编辑设备白名单'
        this.type = 2
        this.isAdmin = false
        if (info.perm === 'admin') {
          this.isAdmin = true
        }
        this.$nextTick(() => {
          this.$refs.dataForm.resetFields()
          this.currentEquipId = info.id
          this.dataForm.deviceName = info.deviceName
          this.dataForm.uniqueAddress = info.uniqueAddress
          this.dataForm.remark = info.remark
        })
      }
    },
    // 取消
    resetForm() {
      this.$refs.dataForm.resetFields()
      this.visible = false
    },
    // 提交
    submitForm() {
      this.$refs.dataForm.validate((valid) => {
        if (valid) {
          if (this.dataForm.deviceName.trim() === '') {
            this.$message.error('设备名称不能是空格')
            return
          }
          if (this.dataForm.uniqueAddress.trim() === '') {
            this.$message.error('设备MAC地址不能是空格')
            return
          }
          const data = {
            deviceName: this.dataForm.deviceName.trim(),
            uniqueAddress: this.dataForm.uniqueAddress.trim(),
            remark: this.dataForm.remark.trim()
          }
          if (this.type === 1) {
            // 新增
            const send = { productId: this.proId, ...data }
            this.add(send)
          } else {
            // 编辑
            const send = { id: this.currentEquipId, ...data }
            this.update(send)
          }
        }
      })
    },
    // 新增
    add(sendData) {
      httpMethods.addEquipment(sendData).then((res) => {
        if (res.resp_code === 0) {
          this.visible = false
          this.$emit('refreshDataList')
          this.$message({
            message: '添加成功',
            type: 'success'
          })
        } else {
          this.$message.error(res.resp_msg)
        }
      })
    },
    // 编辑
    update(sendData) {
      httpMethods.editEquipment(sendData).then((res) => {
        if (res.resp_code === 0) {
          this.visible = false
          this.$emit('refreshDataList')
          this.$message({
            message: '修改成功',
            type: 'success'
          })
        } else {
          this.$message.error(res.resp_msg)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
